var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.save($event)
            }
          }
        },
        [
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col w-full mb-2" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: "Descrição",
                      "label-for": "privacy_form_description"
                    }
                  },
                  [
                    _c("validation-provider", {
                      attrs: { name: "Descrição", rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("complex-editor", {
                                attrs: {
                                  editor_data: _vm.privacy_form_description
                                },
                                on: {
                                  "update:editor_data": function($event) {
                                    _vm.privacy_form_description = $event
                                  }
                                }
                              }),
                              _c("small", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col w-full mb-2" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: "Link Portal Privacidade",
                      "label-for": "privacy_form_link"
                    }
                  },
                  [
                    _c("validation-provider", {
                      attrs: { name: "Link Portal Privacidade" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("b-form-input", {
                                staticClass: "required",
                                attrs: {
                                  id: "privacy_form_link",
                                  state: errors.length > 0 ? false : null,
                                  name: "privacy_form_link"
                                },
                                model: {
                                  value: _vm.privacy_form_link,
                                  callback: function($$v) {
                                    _vm.privacy_form_link = $$v
                                  },
                                  expression: "privacy_form_link"
                                }
                              }),
                              _c("small", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col w-full mb-2" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: "Capacidade civil",
                      "label-for": "privacy_form_message"
                    }
                  },
                  [
                    _c("validation-provider", {
                      attrs: { name: "Mensagem" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("complex-editor", {
                                attrs: {
                                  editor_data: _vm.privacy_form_message
                                },
                                on: {
                                  "update:editor_data": function($event) {
                                    _vm.privacy_form_message = $event
                                  }
                                }
                              }),
                              _c("small", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col w-full mb-2" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("receiving_emails"),
                      "label-for": "emailsInput"
                    }
                  },
                  [
                    _c("validation-provider", {
                      attrs: { name: "emailsInput" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("emails-input", {
                                ref: "emailsInput",
                                attrs: {
                                  emailsInput: _vm.emailsInitialTag,
                                  sendButton: false
                                },
                                on: { emailsChanged: _vm.emailsChanged }
                              }),
                              _c("small", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "flex justify-end mb-4" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "ripple",
                      rawName: "v-ripple.400",
                      value: "rgba(255, 255, 255, 0.15)",
                      expression: "'rgba(255, 255, 255, 0.15)'",
                      modifiers: { "400": true }
                    }
                  ],
                  staticClass: "float-right mr-1",
                  attrs: { variant: "primary", type: "submit" }
                },
                [_vm._v(" Salvar ")]
              ),
              !_vm.hideBackButton
                ? _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: { variant: "outline-secondary" },
                      on: { click: _vm.goBack }
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "CornerUpLeftIcon" }
                      }),
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v(_vm._s(_vm.$t("back")))
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "b-card-code",
            {
              key: _vm.legalEntityId + "-internal",
              attrs: {
                title: "URL Interna",
                codeVisible: "true",
                showCopy: "true",
                codeEmbed: "true"
              },
              scopedSlots: _vm._u([
                {
                  key: "code",
                  fn: function() {
                    return [_vm._v(" " + _vm._s(_vm.internalPrivacyUrl) + " ")]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c("b-card-text", [
                _vm._v(
                  " Use esta URL para direcionar o usuário para o formulário de requisição LGPD em sua INTRANET. "
                )
              ])
            ],
            1
          ),
          _c(
            "b-card-code",
            {
              key: _vm.legalEntityId + "-external",
              attrs: {
                title: "URL Externa",
                codeVisible: "true",
                showCopy: "true",
                codeEmbed: "true",
                shortUrl: _vm.shortUrl
              },
              scopedSlots: _vm._u([
                {
                  key: "code",
                  fn: function() {
                    return [_vm._v(" " + _vm._s(_vm.externalPrivacyUrl) + " ")]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c("b-card-text", [
                _vm._v(
                  " Use esta URL para direcionar o usuário para o formulário de requisição LGPD em sua EXTRANET. "
                )
              ])
            ],
            1
          ),
          _c(
            "b-card-code",
            {
              key: _vm.legalEntityId + "-protocol",
              attrs: {
                title: "Protocolo - Página de Consulta Pública",
                codeVisible: "true",
                showCopy: "true",
                codeEmbed: "true"
              },
              scopedSlots: _vm._u([
                {
                  key: "code",
                  fn: function() {
                    return [_vm._v(" " + _vm._s(_vm.protocolQueryUrl) + " ")]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c("b-card-text", [
                _vm._v(
                  " Use esta URL para realizar consulta da situação e tratamento do formulário de requisição LGPD. "
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }